import messaging from "@react-native-firebase/messaging";
import { useEffect } from "react";
import { Platform } from "react-native";

async function getToken() {
  if (Platform.OS === "web") return;
  try {
    const token = await messaging().getToken();
    console.log("Push notification FCM Token:", token);
    return token;
  } catch (error) {
    console.error("FCM Token retrieval failed:", error);
  }
}

export const getNotificationPermission = async () => {
  if (Platform.OS === "web") return;
  try {
    if (Platform.OS === "ios") {
      await messaging().requestPermission();
    } else if (Platform.OS === "android") {
      const { PermissionsAndroid } = require("react-native");
      await PermissionsAndroid.request(PermissionsAndroid.PERMISSIONS.POST_NOTIFICATIONS);
    }
  } catch (error) {
    console.error("Notification permission check failed: ", error);
  }
};

// This needs to be called in the index.ts file
export const initBackgroundMessaging = () => {
  if (Platform.OS === "web") return;
  messaging().setBackgroundMessageHandler(async (message) => {
    console.log("Push notification (Background):", message);
  });
};

export const useMessaging = () => {
  useEffect(() => {
    if (Platform.OS === "web") return;
    getToken();

    const unsubscribe = messaging().onMessage(async (remoteMessage) => {
      console.log("Push notification (Foreground):", remoteMessage);
      // Optional: Show a local toast/notification here if needed
    });

    return unsubscribe;
  }, []);

  return {};
};
